<template>
  <div class="is-fullhd">
    <div class="box">
      <div class="content has-text-centered">
        <h2 class="is-title is-bold has-text-centered has-text-primary">
          Manage Assessment
        </h2>
      </div>
      <hr></hr>
      <div class="content">
        <p>
          Welcome to the Assessment management page. Here you can add or modify Assessment information.
        </p>
      </div>

      <div class="section" style="padding: 1rem 1rem 1rem 1rem; border: 1px solid whitesmoke; border-radius: 10px;">
        <form>
          <div class="columns">
            <div class="column is-6">
              <div class="field">
                <label class="label">Organization name</label>
                <p class="control">
                  <input class="input" type="text" value="" v-model="client.companyName">
                </p>
              </div>
            </div>
            <div class="column is-6">
              <div class="field">
                <label class="label">Organization logo</label>
                <div class="field">
                  <div class="file is-primary has-name is-fullwidth is-right">
                    <label class="file-label">
                      <input class="file-input" v-on:change="fileChange()" type="file" name="logo" id="logo">
                      <span class="file-cta">
                        <span class="file-icon">
                          <i class="fa fa-upload"></i>
                        </span>
                        <span class="file-label">
                          upload logo
                        </span>
                      </span>
                      <span class="file-name" style="background: #fff; max-width: 6em !important;">
                        {{ pictureName ? pictureName : 'Client Logo'}}
                      </span>
                    </label>
                  </div>
                    <p class="help">Minimum size: width 200px * height 40px</p>
                </div>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column is-6">
              <div class="field">
                <label class="label">Team name</label>
                <p class="control">
                  <input class="input" type="text" value="" v-model="initiative.teamName">
                </p>
              </div>
            </div>
          </div>
          <hr class="navbar-divider" style="background-color: lightgrey;">
          <div class="columns">
            <div class="column is-6">
              <div class="field">
                <label class="label">Initiative name</label>
                <p class="control">
                  <input class="input" type="text" value="" v-model="initiative.name">
                </p>
              </div>
            </div>
            <div class="column is-6">
              <div class="field">
                <label class="label">Assessment due date</label>
                <p class="control has-icon deadlineInput">
                  <datetime v-model="initiative.deadline" :min-datetime="new Date().toISOString()"
                    :max-datetime="new Date(Date.now() + 90 * 24*60*60*1000).toISOString()"
                    :use12-hour="true" type="datetime" :minute-step="15" :auto="true" 
                    :format="{ year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: '2-digit', timeZoneName: 'short' }"
                    :placeholder="initiative.deadline"></datetime>
                  <span class="icon is-small">
                    <i class="fa fa-calendar"></i>
                  </span>
                </p>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column is-12">
              <div class="field">
                <label class="label">Initiative description</label>
                <div class="control">
                  <textarea class="textarea" rows="3" v-model="initiative.initiativeDetails" placeholder="Enter initiative description"></textarea>
                </div>
              </div>
            </div>
          </div>
          <div class="field">
            <p class="control has-text-centered">
              <button @click.prevent="submit()" class="button is-primary">Update</button>
              <button @click.prevent="loadData()" class="button is-light">Reset</button>
            </p>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import * as globalConstants from '../../globalConstants.js'
import {Datetime} from 'vue-datetime'
import FormData from 'form-data'

export default {
  components: {
    datetime: Datetime
  },
  data () {
    return {
      fullPage: true,
      isLoading: true,
      modalOpen: false,
      notVisited: true,
      previewModalOpen: false,
      user: {
        email: '',
        firstName: '',
        lastName: '',
        password: '',
        confirmPassword: '',
        type: '',
        role: '',
        Submitted: false
      },
      client: {
        id: '',
        companyName: '',
        contactPerson: {
          firstName: '',
          lastName: '',
          email: '',
          role: ''
        }
      },
      initiative: {
        id: '',
        name: '',
        deadline: '',
        teamName: '',
        initiativeDetails: '',
        members: []
      },
      pictureName: ''
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    fileChange () {
      var image = document.getElementById('logo').files[0]
      this.pictureName = image.name
    },
    submit () {
      if (this.client.companyName === undefined || this.client.companyName === null || this.client.companyName.trim() === '') {
        this.$noty.error('Please enter your organization name.')
      } else if (this.initiative.teamName === undefined || this.initiative.teamName === null || this.initiative.teamName.trim() === '') {
        this.$noty.error('Please enter your team name.')
      } else if (this.initiative.name === undefined || this.initiative.name === null || this.initiative.name.trim() === '') {
        this.$noty.error('Please enter initiative name.')
      } else if (this.initiative.deadline === undefined || this.initiative.deadline === null || this.initiative.deadline.trim() === '') {
        this.$noty.error('Please set a deadline for the risk assessment.')
      } else {
        this.initiative.deadline = new Date(this.initiative.deadline).toUTCString()
        axios.put(globalConstants.apiURL + '/api/v1/initiatives/' + this.initiative.id, {initiativeName: this.initiative.name, teamName: this.initiative.teamName, initiativeDescription: this.initiative.initiativeDetails, deadline: this.initiative.deadline})
        .then(response1 => {
          this.initiative.deadline = new Date(this.initiative.deadline).toLocaleString()
          var image = document.getElementById('logo').files[0]
          if (image) {
            var fd = new FormData()
            fd.append('file', image, 'file')
            fd.append('clientId', true)
            axios.post(globalConstants.apiURL + '/api/v1/users/' + this.client.id + '/upload', fd, {
              headers: {'Content-Type': undefined}
            }).then(response => {
              this.$store.commit('setClientLogoSrc', globalConstants.apiURL + '/' + response.data.path)
              axios.put(globalConstants.apiURL + '/api/v1/clients/' + this.client.id, { companyName: this.client.companyName, logoPath: response.data.logoPath })
              .then(response => {
                this.$noty.success('Logo updated successfully.')
              })
              .catch(error => {
                console.log('error on saving client' + error.response.data.message)
              })
            })
            .catch(error => {
              console.log(error)
            })
          } else {
            console.log('just ' + this.client.companyName)
            axios.put(globalConstants.apiURL + '/api/v1/clients/' + this.client.id, { companyName: this.client.companyName })
            .then(response => {
              console.log(response)
            })
            .catch(error => {
              console.log('error on saving client' + error.response.data.message)
            })
          }
          this.$noty.success('Assessment updated successfully.')
        })
        .catch(error => {
          this.$noty.error(error.response.data.message)
          console.log('error on saving initiative' + error)
        })
      }
    },
    loadData () {
      let user = JSON.parse(window.localStorage.getItem('user'))
      this.user = user
      axios.get(globalConstants.apiURL + '/api/v1/createdInitiatives/' + user._id)
      .then(response => {
        if (response.data.length > 0) {
          this.initiative.id = response.data[0]._id
          this.initiative.teamLead = response.data[0].teamLead.firstName + ' ' + response.data[0].teamLead.lastName
          this.initiative.teamName = response.data[0].teamName
          this.initiative.name = response.data[0].initiativeName
          this.initiative.deadline = new Date(response.data[0].deadline).toLocaleString()
          this.initiative.members = response.data[0].members
          this.initiative.initiativeDetails = response.data[0].initiativeDescription

          window.localStorage.setItem('Initiative', JSON.stringify({id: response.data[0]._id}))
          axios.get(globalConstants.apiURL + '/api/v1/users/' + user._id)
            .then(response1 => {
              axios.get(globalConstants.apiURL + '/api/v1/clients/' + response1.data.client)
              .then(response2 => {
                this.client.companyName = response2.data.companyName
                this.client.contactPerson = response2.data.contactPerson
                this.client.id = response2.data._id
                if (response2.data.logoPath) {
                  this.$store.commit('setClientLogoSrc', globalConstants.apiURL + '/' + response2.data.logoPath)
                }
              })
              .catch(error => {
                console.log(error)
              })
            })
            .catch(error => {
              console.log(error)
            })
        }
      })
      .catch(error => {
        console.log(error)
      })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// assessmentInfo.vue?48c83d51